// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import TrinidadTobago from '../_raw/flag/icon_flag_trinidad_tobago.png';

export default () => <img src={TrinidadTobago} alt="TrinidadTobago" />;
